module.exports = __webpack_public_path__ + "static/media/check-circle.a544d295.svg";